import { gql, useApolloClient, useMutation } from '@apollo/client'
import { useEffect } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import Heading from 'components/v2/Heading'
import FormLayout from 'features/App/components/FormLayout'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { NewBookingClass } from 'features/BookingClasses/components/NewBookingClass'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { resolvers as loginResolvers } from 'resolvers/login'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'bookingClasses.new.helmet',
    defaultMessage: 'New Booking class | Nexbus Admin'
  }
})

const CREATE_BOOKING_CLASS = gql`
  mutation CreateBookingClass($bookingClass: createBookingClassInput!) {
    createBookingClass(input: $bookingClass)
  }
`

const NewBookingClassView = (): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const client = useApolloClient()
  client.addResolvers(loginResolvers)

  const login = useLogin()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const [createBookingClass, { loading, error }] = useMutation(CREATE_BOOKING_CLASS, {
    onCompleted() {
      navigate('/booking-classes')
    }
  })

  if (!canWrite(FEATURES.BOOKING_CLASS, login.accessToken.policies)) {
    return <ForbiddenView feature={FEATURES.BOOKING_CLASS} />
  }

  const handleSubmit = (bookingClass: TSFixMe): TSFixMe => {
    const payload = {
      companyID: bookingClass.company.id,
      name: bookingClass.name,
      priority: parseInt(bookingClass.priority),
      promo: bookingClass.promo
    }

    createBookingClass({
      variables: {
        bookingClass: payload
      }
    })
  }

  return (
    <div>
      <FormLayout.Header>
        <Heading.H3>
          <FormattedMessage id="bookingClass.new.title" defaultMessage="Add booking class" />
        </Heading.H3>
      </FormLayout.Header>

      <FormLayout.Content>
        <NewBookingClass onSubmit={handleSubmit} loading={loading} error={error} />
      </FormLayout.Content>
    </div>
  )
}

export default withLastUrl(NewBookingClassView)
